export default function getError(error) {
  function isObj(obj) {
    var type = typeof obj;
    return type === "function" || (type === "object" && !!obj);
  }
  const value = isObj(error) ? Object.values(error)[0] : error;
  // console.log("ERROR VALUE", value);
  return value ?? "An unexpected error occurred";
}
